import { render } from "./userauth.vue?vue&type=template&id=46cbb78b"
import script from "./userauth.vue?vue&type=script&lang=js"
export * from "./userauth.vue?vue&type=script&lang=js"

import "./userauth.vue?vue&type=style&index=0&id=46cbb78b&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__